'use client';

var _jsxFileName = "/builds/zillow/hackweek/military-rent-affordability-calculator/src/components/MilitaryRentAffordabilityCalculator/mrac-income-debt-form/index.jsx",
    _this = this;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import styled from 'styled-components';
import { AdornedInput, Adornment, Card, Flex, FormField, FormHelp, Grid, Input, Label, Paragraph, Select } from '@zillow/constellation';
import Statement from '../mrac-income-debt-statement';
import Slider from '../slider';
import { getMonthlyActiveBasePay, getMonthlyBahValue } from '../militaryUtils';
import { MIL_AREAS_TO_NAMES, MIL_PAYGRADES, MIL_LENGTH_OF_SERVICE_OPTIONS, MIL_ZIPCODES_TO_AREAS, MIL_ACTIVE_BASE_PAY_LOOKUP } from '../militaryData';
import MilitaryBahStatement from '../mrac-bah-statement';
import MilitaryBasePayStatement from '../mrac-base-pay-statement';
var GridWithMargin = styled(Grid).withConfig({
  displayName: "mrac-income-debt-form__GridWithMargin",
  componentId: "sc-ymtjtx-0"
})(["margin:30px;"]);
var GridWithPadding = styled(Grid).withConfig({
  displayName: "mrac-income-debt-form__GridWithPadding",
  componentId: "sc-ymtjtx-1"
})(["padding-top:6px;"]);

var IncomeDebtForm = function IncomeDebtForm() {
  var _useState = useState({
    militaryPaygrade: null,
    zipCode: null,
    location: null,
    locationCode: null,
    dependants: null,
    monthlyBah: null,
    monthlyActiveDutyBasePay: null
  }),
      _useState2 = _slicedToArray(_useState, 2),
      militaryInfo = _useState2[0],
      setMilitaryInfo = _useState2[1];

  var _useState3 = useState({
    monthlyNetIncomePretax: 0,
    monthlyNetIncome: 0,
    monthlySupplementalIncome: 0,
    monthlyDebtsAndExpenses: 0
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      incomeAndDebt = _useState4[0],
      setIncomeAndDebt = _useState4[1];

  var _useState5 = useState(Math.round(incomeAndDebt.monthlyNetIncomePretax * 0.33)),
      _useState6 = _slicedToArray(_useState5, 2),
      rent = _useState6[0],
      setRent = _useState6[1];

  var _useState7 = useState({
    monthlySupplementalIncome: '',
    monthlyDebtsAndExpenses: ''
  }),
      _useState8 = _slicedToArray(_useState7, 2),
      errors = _useState8[0],
      setErrors = _useState8[1];

  var overBudget = incomeAndDebt.monthlyNetIncome - Math.max(rent - (militaryInfo.monthlyBah || 0), 0) - incomeAndDebt.monthlyDebtsAndExpenses < 0;

  var buildIncomeState = function buildIncomeState(monthlyActiveDutyBasePay, monthlyBah, supplementalIncome) {
    var updatedNetIncome = (monthlyActiveDutyBasePay || 0) + (supplementalIncome || 0) + (monthlyBah || 0);
    var updatedNetIncomePretax = Math.round(updatedNetIncome / 0.75);
    return {
      monthlyNetIncomePretax: updatedNetIncomePretax,
      monthlyNetIncome: updatedNetIncome
    };
  };

  var shouldHideLengthOfServiceOption = function shouldHideLengthOfServiceOption(optionValue) {
    if (militaryInfo.militaryPaygrade == null) {
      return false;
    }

    return MIL_ACTIVE_BASE_PAY_LOOKUP[militaryInfo.militaryPaygrade][optionValue] == null;
  };

  var updateMilitaryInfo = function updateMilitaryInfo(e, field) {
    var _statePatch;

    var value = e.target.value;
    var statePatch = (_statePatch = {}, _statePatch[field] = value, _statePatch);

    if (field === 'zipCode') {
      var area = MIL_ZIPCODES_TO_AREAS[value];

      if (area === undefined) {
        statePatch[field] = null;
        statePatch.location = null;
        statePatch.locationCode = null;
      } else {
        statePatch.locationCode = area;
        statePatch.location = MIL_AREAS_TO_NAMES[area];
      }
    }

    if (field === 'militaryPaygrade') {
      if (militaryInfo.lengthOfService != null && militaryInfo.lengthOfService != null && MIL_ACTIVE_BASE_PAY_LOOKUP[value][militaryInfo.lengthOfService] == null) {
        statePatch.lengthOfService = null;
      }
    }

    setMilitaryInfo(function (prevState) {
      var newState = Object.assign({}, prevState, statePatch);

      if (newState.militaryPaygrade != null && newState.lengthOfService != null) {
        newState.monthlyActiveDutyBasePay = getMonthlyActiveBasePay(newState.militaryPaygrade, newState.lengthOfService);
      } else {
        newState.monthlyActiveDutyBasePay = null;
      }

      if (newState.militaryPaygrade != null && newState.zipCode != null && newState.dependants != null) {
        newState.monthlyBah = getMonthlyBahValue(newState.militaryPaygrade, newState.zipCode, newState.dependants);
      } else {
        newState.monthlyBah = null;
      }

      var updatedIncomeAndDebt = buildIncomeState(newState.monthlyActiveDutyBasePay, newState.monthlyBah, incomeAndDebt.monthlySupplementalIncome);
      setRent(Math.round(updatedIncomeAndDebt.monthlyNetIncomePretax * 0.33));
      setIncomeAndDebt(function (prevIncomeAndDebtState) {
        return Object.assign({}, prevIncomeAndDebtState, updatedIncomeAndDebt);
      });
      return newState;
    });
  };

  var updateIncomeAndDebt = function updateIncomeAndDebt(e, type) {
    var updatedIncomeAndDebt = {};
    var expenseValueValidity = '';
    var expenseValue = parseFloat(e.target.value);

    if (type === 'monthlySupplementalIncome') {
      if (!expenseValue) {
        expenseValueValidity = 'Please enter valid income value';
      }

      updatedIncomeAndDebt = buildIncomeState(militaryInfo.monthlyActiveDutyBasePay, militaryInfo.monthlyBah, expenseValue);
      setRent(Math.round(updatedIncomeAndDebt.monthlyNetIncomePretax * 0.33));
    }

    if (type === 'monthlyDebtsAndExpenses') {
      var _updatedIncomeAndDebt;

      if (!expenseValue) {
        expenseValueValidity = 'Please enter valid debts/expenses value';
      }

      updatedIncomeAndDebt = (_updatedIncomeAndDebt = {}, _updatedIncomeAndDebt[type] = expenseValue || 0, _updatedIncomeAndDebt);
    }

    setIncomeAndDebt(function (prevState) {
      return Object.assign({}, prevState, updatedIncomeAndDebt);
    });
    setErrors(function (prevState) {
      var _Object$assign;

      return Object.assign({}, prevState, (_Object$assign = {}, _Object$assign[type] = expenseValueValidity, _Object$assign));
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 198,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    gap: "sm",
    flexDirection: {
      default: 'column',
      lg: 'row'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 199,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(FormField, {
    label: /*#__PURE__*/React.createElement(Label, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 201,
        columnNumber: 28
      }
    }, "Military Paygrade"),
    control: /*#__PURE__*/React.createElement(Select, {
      description: /*#__PURE__*/React.createElement(FormHelp, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 204,
          columnNumber: 42
        }
      }, "errors.idk"),
      onChange: function onChange(e) {
        updateMilitaryInfo(e, 'militaryPaygrade');
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 203,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement("option", {
      key: "placeholder",
      disabled: true,
      selected: true,
      hidden: true,
      value: "",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 209,
        columnNumber: 29
      }
    }, "Select option"), MIL_PAYGRADES.map(function (value) {
      return /*#__PURE__*/React.createElement("option", {
        key: value,
        value: value,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 213,
          columnNumber: 33
        }
      }, value);
    })),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 200,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement(FormField, {
    label: /*#__PURE__*/React.createElement(Label, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 221,
        columnNumber: 28
      }
    }, "Length of Service"),
    control: /*#__PURE__*/React.createElement(Select, {
      description: /*#__PURE__*/React.createElement(FormHelp, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 224,
          columnNumber: 42
        }
      }, "errors.idk"),
      onChange: function onChange(e) {
        updateMilitaryInfo(e, 'lengthOfService');
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 223,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement("option", {
      key: "placeholder",
      disabled: true,
      selected: true,
      hidden: true,
      value: "",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 229,
        columnNumber: 29
      }
    }, "Select option"), MIL_LENGTH_OF_SERVICE_OPTIONS.map(function (value) {
      return /*#__PURE__*/React.createElement("option", {
        key: value,
        value: value,
        hidden: shouldHideLengthOfServiceOption(value),
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 233,
          columnNumber: 33
        }
      }, value);
    })),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 220,
      columnNumber: 17
    }
  })), /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    gap: "sm",
    flexDirection: {
      default: 'column',
      lg: 'row'
    },
    marginTop: "sm",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 245,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(FormField, {
    label: /*#__PURE__*/React.createElement(Label, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 252,
        columnNumber: 28
      }
    }, "Zip Code"),
    control: /*#__PURE__*/React.createElement(Input, {
      id: "zip-code",
      maxLength: 5,
      onChange: function onChange(e) {
        updateMilitaryInfo(e, 'zipCode');
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 254,
        columnNumber: 25
      }
    }),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 251,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement(FormField, {
    label: /*#__PURE__*/React.createElement(Label, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 265,
        columnNumber: 28
      }
    }, "Dependants"),
    control: /*#__PURE__*/React.createElement(Select, {
      description: /*#__PURE__*/React.createElement(FormHelp, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 268,
          columnNumber: 42
        }
      }, "errors.idk"),
      onChange: function onChange(e) {
        updateMilitaryInfo(e, 'dependants');
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 267,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement("option", {
      key: "placeholder",
      disabled: true,
      selected: true,
      hidden: true,
      value: "",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 273,
        columnNumber: 29
      }
    }, "Select option"), /*#__PURE__*/React.createElement("option", {
      key: "Yes",
      value: "true",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 276,
        columnNumber: 29
      }
    }, "Yes"), /*#__PURE__*/React.createElement("option", {
      key: "No",
      value: "false",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 279,
        columnNumber: 29
      }
    }, "No")),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 264,
      columnNumber: 17
    }
  })), /*#__PURE__*/React.createElement(Flex, {
    display: "flex",
    gap: "sm",
    flexDirection: {
      default: 'column',
      lg: 'row'
    },
    marginTop: "sm",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 286,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(FormField, {
    label: /*#__PURE__*/React.createElement(Label, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 293,
        columnNumber: 28
      }
    }, "Monthly supplemental income"),
    error: errors.monthlySupplementalIncome !== '',
    control: /*#__PURE__*/React.createElement(AdornedInput, {
      leftAdornment: /*#__PURE__*/React.createElement(Adornment, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 297,
          columnNumber: 44
        }
      }, "$"),
      input: /*#__PURE__*/React.createElement(Input, {
        id: "income-post-tax",
        placeholder: "Misc. post-tax income",
        defaultValue: incomeAndDebt.monthlySupplementalIncome,
        maxLength: 7,
        onChange: function onChange(e) {
          updateIncomeAndDebt(e, 'monthlySupplementalIncome');
        },
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 299,
          columnNumber: 33
        }
      }),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 296,
        columnNumber: 25
      }
    }),
    description: /*#__PURE__*/React.createElement(FormHelp, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 312,
        columnNumber: 34
      }
    }, errors.monthlySupplementalIncome),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 292,
      columnNumber: 17
    }
  }), /*#__PURE__*/React.createElement(FormField, {
    label: /*#__PURE__*/React.createElement(Label, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 315,
        columnNumber: 28
      }
    }, "Monthly debts and expenses"),
    error: errors.monthlyDebtsAndExpenses !== '',
    control: /*#__PURE__*/React.createElement(AdornedInput, {
      leftAdornment: /*#__PURE__*/React.createElement(Adornment, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 319,
          columnNumber: 44
        }
      }, "$"),
      input: /*#__PURE__*/React.createElement(Input, {
        id: "monthly-debts",
        placeholder: "Bills, savings, ...",
        defaultValue: incomeAndDebt.monthlyDebtsAndExpenses,
        maxLength: 7,
        onChange: function onChange(e) {
          updateIncomeAndDebt(e, 'monthlyDebtsAndExpenses');
        },
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 321,
          columnNumber: 33
        }
      }),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 318,
        columnNumber: 25
      }
    }),
    description: /*#__PURE__*/React.createElement(FormHelp, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 334,
        columnNumber: 34
      }
    }, errors.monthlyDebtsAndExpenses),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 314,
      columnNumber: 17
    }
  })), /*#__PURE__*/React.createElement(Card, {
    cardType: "secondary",
    cardElevation: 0,
    marginY: "xl",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 337,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    display: "grid",
    gridTemplateColumns: "1fr",
    justifyItems: "center",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 338,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(MilitaryBasePayStatement, {
    militaryPaygrade: militaryInfo.militaryPaygrade,
    lengthOfService: militaryInfo.lengthOfService,
    basePay: militaryInfo.monthlyActiveDutyBasePay,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 339,
      columnNumber: 21
    }
  }), /*#__PURE__*/React.createElement(MilitaryBahStatement, {
    militaryPaygrade: militaryInfo.militaryPaygrade,
    zipCode: militaryInfo.zipCode,
    dependants: militaryInfo.dependants,
    monthlyBah: militaryInfo.monthlyBah,
    location: militaryInfo.location,
    locationCode: militaryInfo.locationCode,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 344,
      columnNumber: 21
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    display: "grid",
    gridTemplateColumns: {
      default: '1fr 1fr',
      md_lte: '1fr'
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 353,
      columnNumber: 17
    }
  }, /*#__PURE__*/React.createElement(GridWithMargin, {
    display: "grid",
    justifyItems: "center",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 354,
      columnNumber: 21
    }
  }, /*#__PURE__*/React.createElement(Paragraph, {
    fontType: "h4",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 355,
      columnNumber: 25
    }
  }, overBudget ? "You're overbudget at $" + rent + "/mo" : "You can afford $" + rent + "/mo"), /*#__PURE__*/React.createElement(Statement, {
    incomeAndDebt: incomeAndDebt,
    rent: rent,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 360,
      columnNumber: 25
    }
  }), /*#__PURE__*/React.createElement(Paragraph, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 361,
      columnNumber: 25
    }
  }, 'You will have ', /*#__PURE__*/React.createElement("strong", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 363,
      columnNumber: 29
    }
  }, "$" + Math.round(incomeAndDebt.monthlyNetIncome - rent - incomeAndDebt.monthlyDebtsAndExpenses) + "/mo"), ' left to spend.')), /*#__PURE__*/React.createElement(GridWithMargin, {
    display: "grid",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 371,
      columnNumber: 21
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    alignSelf: "end",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 372,
      columnNumber: 25
    }
  }, /*#__PURE__*/React.createElement(Slider, {
    id: "rent-value-slider",
    className: "rent-value-slider",
    min: Math.round(incomeAndDebt.monthlyNetIncomePretax * 0.1),
    max: Math.round(incomeAndDebt.monthlyNetIncomePretax * 0.4),
    value: rent,
    incomeAndDebt: incomeAndDebt,
    step: Math.round((incomeAndDebt.monthlyNetIncomePretax * 0.4 - incomeAndDebt.monthlyNetIncomePretax * 0.1) / 30),
    onChange: function onChange(e) {
      return setRent(e);
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 373,
      columnNumber: 29
    }
  })), /*#__PURE__*/React.createElement(GridWithPadding, {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(0, 1fr))",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 388,
      columnNumber: 25
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 392,
      columnNumber: 29
    }
  }, "10%"), /*#__PURE__*/React.createElement(Grid, {
    display: "grid",
    justifySelf: "end",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 393,
      columnNumber: 29
    }
  }, "40%"))))), /*#__PURE__*/React.createElement(Paragraph, {
    fontType: "finePrint",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 400,
      columnNumber: 13
    }
  }, /*#__PURE__*/React.createElement("strong", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 401,
      columnNumber: 17
    }
  }, "DISCLAIMER:"), " This tool assumes a tax rate of 25%, the calculated output is just a suggestion. All personal and financial factors should be considered before signing a lease."));
};

export default IncomeDebtForm;